import { queryClient } from 'App';
import debounce from 'lodash/debounce';

import { appointmentQueryKeys } from 'lib/constants/queries/queryKeys';

export default debounce((data) => {
  const { appointment, invalidate } = data;

  appointmentQueryKeys.forEach((key) => {
    queryClient.invalidateQueries({
      queryKey: [key],
      exact: false
    });
  });
  if (invalidate) return;

  queryClient.setQueryData(['appointmentv2', appointment?.id], (oldData) => {
    if (!oldData) return;
    return {
      ...oldData,
      appointment: { ...(oldData?.appointment || {}), ...appointment }
    };
  });
}, 300);
